import { Command as CommandPrimitive } from 'cmdk';
import { forwardRef } from 'react';
import { cn } from '@/shared/lib/utils';

export const CommandItem = forwardRef<
  React.ElementRef<typeof CommandPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof CommandPrimitive.Item>
>(({ className, onFocus, ...props }, ref) => (
  <CommandPrimitive.Item
    ref={ref}
    tabIndex={0}
    onFocus={(e) => {
      e.currentTarget.dispatchEvent(new PointerEvent('pointermove', { bubbles: true }));
      onFocus?.(e);
    }}
    className={cn(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-surface-accent data-[selected=true]:text-text-accent data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      'cursor-pointer hover:bg-stone-50',
      className,
    )}
    {...props}
  />
));

CommandItem.displayName = CommandPrimitive.Item.displayName;
